import { h, render } from "preact";
import Layout from "./layout";

render(<Layout />, document.getElementById("app"));
